export default __webpack_public_path__ + "static/media/IMG_3530.63bb0f68.jpg";